<div
  [class]="
    'flex flex-row justify-between gap-4 items-center px-4 py-3 rounded shadow-md max-w-sm state-' +
    state
  "
>
  <div class="flex items-center gap-3">
    <i [class]="'fa-solid ' + getIconClass() + ' state-icon-' + state"></i>
    <span matSnackBarLabel>
      {{ message }}
    </span>
  </div>

  <i
    class="fa-solid fa-xmark cursor-pointer"
    (keydown.enter)="snackBarRef.dismiss()"
    (click)="snackBarRef.dismiss()"
    tabindex="0"
  ></i>
</div>
